<template>
  <div class="cases">
		<transition-group appear enter-active-class="scaleIn" leave-active-class="scaleFull" mode="out-in">
			<case-thumb v-for="item of cases" :key="item.slug" :item="item" @click="select($event)" />
		</transition-group>
  </div>
</template>

<script>
import CaseThumb from '@/components/CaseThumb'

export default {
	name: 'Home',
	beforeRouteLeave(from, to, next) {
		setTimeout(() => {

			if(this.selected) {
				this.selected.classList.add('caseOpened')
				setTimeout(() => {
					this.selected.classList.remove('caseOpened')
					next()
				}, 180)
			} else {
				next()
			}

		}, 0)
	},
	data() {
		return {
			selected: null
		}
	},
	methods: {
		select(e) { this.selected = e }
	},
	computed: {
		cases() {
			return this.$store.state.cases
		}
	},
  components: {
    CaseThumb
  }
}
</script>
